import { BaseDialects } from '@insights-ltd/design-library/utils';
import { PronounSupport } from 'domain/pronouns';
import { EventType } from './types';

export type AdditionalDialectOptions = 'evaluation-dialect';

export type AllDialectOptions = Dialects | AdditionalDialectOptions;

export type Dialects = BaseDialects | 'is-IS' | 'th-TH';

export type DialectCodes = { [key: string]: AllDialectOptions };

export interface DialectDetail extends PronounSupport {
  textKey: string;
  eventType: EventType[];
}

export type DialectDetails = {
  [key in AllDialectOptions]?: DialectDetail;
};

export type ProfileDialectStrategies = 'SINGLE_DIALECT' | 'EVALUATION_DIALECT';

const SUPPORTED_DIALECTS_LIST = [
  'da-DK',
  'de-DE',
  'en-GB',
  'es-ES',
  'fr-FR',
  'nl-NL',
  'pl-PL',
  'it-IT',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'ja-JP',
  'ro-RO',
  'cs-CZ',
  'ko-KR',
  'sv-SE',
  'uk-UA',
  'sr-RS',
  'el-GR',
  'zh-CN',
  'vi-VN',
  'tr-TR',
] as const;
export type PreferredDialect = Extract<
  Dialects,
  (typeof SUPPORTED_DIALECTS_LIST)[number]
>;
export const SUPPORTED_DIALECTS: readonly PreferredDialect[] =
  SUPPORTED_DIALECTS_LIST;

const BETA_SUPPORTED_DIALECTS_LIST = [
  'da-DK',
  'de-DE',
  'en-GB',
  'es-ES',
  'fr-FR',
  'nl-NL',
  'pl-PL',
  'it-IT',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'ja-JP',
  'ro-RO',
  'cs-CZ',
  'ko-KR',
  'sv-SE',
  'uk-UA',
  'sr-RS',
  'el-GR',
  'zh-CN',
  'vi-VN',
  'tr-TR',
] as const;
export type PreferredBetaDialect = Extract<
  Dialects,
  (typeof BETA_SUPPORTED_DIALECTS_LIST)[number]
>;
export const BETA_SUPPORTED_DIALECTS: readonly PreferredBetaDialect[] =
  BETA_SUPPORTED_DIALECTS_LIST;
